import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { StatusEnum } from "../../../commons/enums/status-enum";
import { PaginatedEnsueCollection } from "../../../ensue-react-system/utilities/paginated-ensue-collection";
import { User } from "../../../commons/models/user";
import { manageUserService } from "../../../commons";
import {QueryParamOptions} from "../../../commons/types/query-param-options";

export interface IManageUserListState {
  userList: PaginatedEnsueCollection<User>;
  userListStatus: StatusEnum;
}

const initialState: IManageUserListState = {
  userList: new PaginatedEnsueCollection<User>(),
  userListStatus: StatusEnum.Idle,
};

export const fetchManageUserList = createAsyncThunk(
  "manage/userList",
  async (options: QueryParamOptions, thunkAPI) => {
    try {
      const userList = await manageUserService.list(undefined, {
        ...options,
      });
      return userList as PaginatedEnsueCollection<User>;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const footballManageUserListSlice = createSlice({
  name: "footballManageUserList",
  initialState: initialState,
  reducers: {
    cleanUpUserList(state) {
      state.userList = new PaginatedEnsueCollection<User>();
      state.userListStatus = StatusEnum.Idle;
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchManageUserList.pending, (state) => {
        state.userListStatus = StatusEnum.Loading;
      })
      .addCase(
        fetchManageUserList.fulfilled,
        (state, action: PayloadAction<PaginatedEnsueCollection<User>>) => {
          state.userListStatus = StatusEnum.Succeeded;
          state.userList = action.payload;
        }
      )
      .addCase(fetchManageUserList.rejected, (state) => {
        state.userListStatus = StatusEnum.Failed;
      });
  },
});

export const { cleanUpUserList } = footballManageUserListSlice.actions;
export default footballManageUserListSlice.reducer;
